import React from "react";
import SecurityGroups from "../../openstack/securitygroups/SecurityGroups";
import NetworksList from "../../openstack/network/NetworksList";
import ExternalIP from "../../openstack/network/ExternalIP";
import Flavors from "../../openstack/flavor/Flavors";
import KeyPairs from "../../openstack/keypair/KeyPairs";
import { CustomComponentProps } from "../types";
import { Grid } from "semantic-ui-react";
import SelectField from "./form-fields/SelectField";

const CustomComponent: React.FC<CustomComponentProps> = ({
  title,
  value,
  format,
  commonProps,
  schema,
}) => {
  const { properties } = schema;

  switch (format) {
    case "securityGroups":
      return (
        <div className="separator">
          <Grid>
            <SecurityGroups
              {...commonProps}
              selectedSecurityGroups={value || []}
            />
          </Grid>
        </div>
      );
    case "networks":
      return (
        <div className="separator">
          <Grid>
            <NetworksList {...commonProps} selectedNetworks={value || []} />
          </Grid>
        </div>
      );
    case "externalNetwork":
      return (
        <div className="separator">
          <Grid>
            <ExternalIP {...commonProps} title={title} />
          </Grid>
        </div>
      );
    case "flavor":
      const minRam = properties?.flavor?.properties?.ram?.minimum;
      const maxRam = properties?.flavor?.properties?.ram?.maximum;
      const minCores = properties?.flavor?.properties?.cores?.minimum;
      const maxCores = properties?.flavor?.properties?.cores?.maximum;
      const flavorTypes = Array.isArray(
        properties?.flavor?.properties?.profile?.default,
      )
        ? properties?.flavor?.properties?.profile?.default
        : properties?.flavor?.properties?.profile?.default !== undefined
          ? [properties?.flavor?.properties?.profile?.default]
          : undefined;

      return (
        <div className="separator">
          <Grid>
            <Flavors
              {...commonProps}
              minRam={minRam}
              maxRam={maxRam}
              minCores={minCores}
              maxCores={maxCores}
              flavorTypes={flavorTypes}
            />
          </Grid>
        </div>
      );
    case "keypair":
      const allowedKeyTypes = properties?.keypair?.allowedKeyTypes;
      return (
        <div className="separator">
          <Grid>
            <KeyPairs {...commonProps} allowedKeyTypes={allowedKeyTypes} />
          </Grid>
        </div>
      );
    case "select":
      const enumValues = properties[commonProps.inputKey]?.enum;
      return (
        <Grid>
          <SelectField
            inputKey={commonProps.inputKey}
            title={title}
            value={value}
            options={enumValues || []}
            handleChange={commonProps.handleChange}
            isRequired={commonProps.isRequired}
            errorMessage={commonProps.errorMessage}
          />
        </Grid>
      );

    default:
      return null;
  }
};

export default CustomComponent;
